"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var stringField = function stringField(value, options) {
  if (typeof value !== 'string') return '';
  var formatted = value.trim().replace(/,/g, '');
  if (options !== null && options !== void 0 && options.replaceHyphens) formatted = formatted.replace(/-/g, '_');
  if (options !== null && options !== void 0 && options.toUpperCase) formatted = formatted.toUpperCase();else formatted = formatted.toLowerCase();
  if (options !== null && options !== void 0 && options.removeSpaces) formatted = formatted.replace(/\s/g, '');else formatted = formatted.replace(/\s/g, '_');
  return formatted.replace(/_{2,}/g, '_');
};
var _default = exports["default"] = stringField;